export default __webpack_public_path__ + "static/media/power-point.6602459c.svg";